const SDG_LIST = 'bfb/SDG/SDG_LIST';
const SDG_LIST_SUCCEEDED = 'bfb/SDG/SDG_LIST_SUCCEEDED';
const SDG_LIST_FAILED = 'bfb/SDG/SDG_LIST_FAILED';

export default {
  SDG_LIST,
  SDG_LIST_SUCCEEDED,
  SDG_LIST_FAILED,
};
